<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col :span="5">
            </a-col>
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                            <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                            <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">未开班</a-select-option>
                            <a-select-option :key="1" :value="1">已开班</a-select-option>
                            <a-select-option :key="2" :value="2">已结班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.user_type" placeholder="老师/班主任" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">老师</a-select-option>
                            <a-select-option :key="1" :value="1">班主任</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear>
                            <a-select-option :key="-1" value="">全部</a-select-option>
                            <a-select-option :key="0" value="寒假">寒假</a-select-option>
                            <a-select-option :key="1" value="春季">春季</a-select-option>
                            <a-select-option :key="2" value="暑假">暑假</a-select-option>
                            <a-select-option :key="3" value="秋季">秋季</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear>
                            <a-select-option :key="-1" value="">全部</a-select-option>
							<a-select-option :key="5" value="2026">2026年</a-select-option>
							<a-select-option :key="5" value="2025">2025年</a-select-option>
							<a-select-option :key="4" value="2024">2024年</a-select-option>
                            <a-select-option :key="3" value="2023">2023年</a-select-option>
                            <a-select-option :key="2" value="2022">2022年</a-select-option>
                            <a-select-option :key="0" value="2021">2021年</a-select-option>
                            <a-select-option :key="1" value="2020">2020年</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select v-model="searchFrom.type" placeholder="班型" allow-clear style="width: 120px;">
                            <a-select-option :key="0" :value="0">培优</a-select-option>
                            <a-select-option :key="1" :value="1">提高</a-select-option>
                            <a-select-option :key="2" :value="2">英才</a-select-option>
                            <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
                            <a-select-option :key="4" :value="4">体验课</a-select-option>
							   <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-input placeholder="姓名" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="表格">
                    <a-table :dataSource="tabledata" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                        @change="onPaginationChange" bordered>
                        <a-table-column key="nickname" title="名字" data-index="nickname" />
                        <a-table-column key="actualcount" title="总人数" data-index="actualcount" />
                        <a-table-column key="statisticcount" title="正常参测" data-index="statisticcount" />

                        <a-table-column key="nocc" title="不参测" data-index="nocc" />
                        <!-- <a-table-column key="statistic" title="正常参测" data-index="statistic" />
                   
                        <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                        <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                        <a-table-column key="type" title="班型">
                            <template slot-scope="item">
                                <span v-if="item.type==0">培优班</span>
                                <span v-if="item.type==1">提高班</span>
                                <span v-if="item.type==2">英才班</span>
                                <span v-if="item.type==3">1对1VIP班</span>
                            </template>
                        </a-table-column>
                        <a-table-column key="status" width="100px;" title="状态">
                            <template slot-scope="item">
                                <span v-if="item.status==1">可用</span>
                                <span v-if="item.status==0">已禁用</span>
                            </template>
                        </a-table-column> 
                      -->
                    </a-table>
                </a-tab-pane>

                <a-tab-pane key="2" tab="图表" force-render>
                    <!--    <v-chart :forceFit="true" :height="400" :data="piedata" :scale="scale">
                        <v-tooltip :showTitle="false" dataKey="item*percent" />
                        <v-axis />
                        <v-legend dataKey="item" />
                        <v-pie position="percent" color="item" :v-style="pieStyle" :label="labelConfig" />
                        <v-coord type="theta" />
                    </v-chart> -->

                    <a-divider></a-divider>
                    <v-chart :forceFit="true" :padding="padding" :height="heightx" :data="chartdata">
                        <v-coord type="rect" direction="LB" />
                        <v-tooltip />
                        <v-legend />
                        <v-axis dataKey="label" label="nickname" />
                        <v-axis dataKey="label" position="right" />
                        <v-stack-bar position="nickname*value" color="type" />
                    </v-chart>
                </a-tab-pane>
            </a-tabs>



        </div>


    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
const DataSet = require('@antv/data-set');

export default {
    components: {
        AFormItem
    },
    data() {
        return {
            tabledata: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 9999
            },
            padding: [10, 80, 50, 100],
            loading: false,
            courseList: [],
            searchFrom: {
                keyword: undefined,
                grade_id: undefined,
                campus_id: undefined,
                type: undefined,
                opening: 1,
                user_type: 0,
                semester_name: '寒假',
                year_name: '2021'
            },

            dataviser: [],
            label: {
                offset: 12
            },
            campusList: [],
            gradeList: [],
            campuscount: [],
        };
    },
    mounted() {
        this.getCampusList();
        this.getGradeList();
    },
    computed: {
        chartdata() {
            //  let me = this 
            const sourceData = [];
            this.tabledata.forEach(row => {
                row['不参测人数'] = Number(row['nocc']);
                row['参测人数'] = Number(row['statisticcount']);
                sourceData.push(row);
            });
            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['参测人数', '不参测人数'],
                key: 'type',
                value: 'value',
                retains: ['nickname'],
            });
            const dataviser = dv.rows;
            return dataviser;
        },


        heightx() {
            return this.tabledata.length * 50;
        }

    },

    methods: {
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", {
                    pageinfo: {
                        pageSize: 9999
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/admin/getmycampuslist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data;
                        this.tableSearch();
                        this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        changeCampus(e) {
            this.searchForm.campus_id = e;
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getTableList(this.searchFrom);
        },
        getTableList(data) {
            this.loading = true;
            this.$axios
                .post("/api/AnalyseInfo/teacher_userlist", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {

                        this.tabledata = res.data;

                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        }
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
